<template>
  <div class="recent-items">
    <activity-actions />
    <tol-table :table-data="userActivity" :columns="columns" :class="{ small: isProfileListing }">
      <template v-slot:tableHeader>
        <th-sortable
          :direction="currentSortField === 'initiatedAt' ? currentSortDirection : 'none'"
          field-name="initiatedAt"
          @change="onSortOrderChange"
          >{{ $t('userActivity.listing.labels.date') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'username' ? currentSortDirection : 'none'"
          field-name="username"
          @change="onSortOrderChange"
          >{{ $t('userActivity.listing.labels.user') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'action' ? currentSortDirection : 'none'"
          field-name="action"
          @change="onSortOrderChange"
          >{{ $t('userActivity.listing.labels.action') }}</th-sortable
        >

        <!--<th></th> -->
      </template>
      <template v-slot:action="{ value }">
        <span>{{ value.action | readable | capitalize }}</span>
        <router-link :to="`${value.description.urlPart}/${value.objectReferenceNumber}`">
          <span>
            <font-awesome-icon v-if="value.action !== 'LOGIN'" :icon="value.description.icon" />
          </span>
          <span v-if="value.action !== 'LOGIN'">{{ value.description.label }}</span>
        </router-link>
      </template>
      <template v-slot:initiatedAt="{ value }">
        {{ value.initiatedAt | formatDateTime }}
      </template>

      <template v-slot:username="{ value }">
        <span><font-awesome-icon icon="laptop"/></span>
        <router-link :to="`users/${value.userReferenceNumber}`">
          {{ value.username }}
        </router-link>
      </template>
    </tol-table>

    <Pagination
      :records-per-page="itemsPerPage"
      :offset="currentPage"
      :record-count="recordCount"
      :class="{ small: isProfileListing }"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>

<script>
import TolTable from '@/app/components/TolTable';
import Pagination from '@/app/components/Pagination';
import ThSortable from '@/app/components/ThSortable';
import ActivityActions from '@/app/features/user-activity/components/ActivityActions.vue';
import {
  UserActivityGetters,
  UserActivityActions
} from '@/app/features/user-activity/user-activity.keys';
import { AppActions } from '@/app/app.keys';

export default {
  name: 'UserActivity',
  components: {
    TolTable,
    Pagination,
    ThSortable,
    ActivityActions
  },
  props: {
    isProfileListing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    recentItemsPerPage() {
      return this.$store.getters[UserActivityGetters.UserActivityPerPage];
    },
    currentPage() {
      return this.$store.getters[UserActivityGetters.UserActivityListingOffset];
    },
    userActivityCount() {
      return this.$store.getters[UserActivityGetters.UserActivityFilteredSortedRecordCount];
    },
    userActivity() {
      return this.$store.getters[UserActivityGetters.UserActivityList];
    },
    columns() {
      return ['initiatedAt', 'username', 'action'];
    },
    currentSortField() {
      return this.$store.getters[UserActivityGetters.SortBy];
    },
    currentSortDirection() {
      return this.$store.getters[UserActivityGetters.SortDirection];
    },
    itemsPerPage() {
      return this.$store.getters[UserActivityGetters.UserActivityPerPage];
    },
    recordCount() {
      return this.$store.getters[UserActivityGetters.UserActivityFilteredRecordCount];
    },
    userId() {
      return this.$store.state.currentUser.id;
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('userActivity.listing.title'));
  },
  methods: {
    onChangePaginationParams(event) {
      this.$store.dispatch(UserActivityActions.SetUserActivityPaginationParameters, {
        pagination: event,
        userId: this.userId
      });
    },
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(UserActivityActions.SetUserActivitySortOrder, {
        sortOrder,
        userId: this.userId
      });
    },
    onDeleteItem(value) {
      this.$store.dispatch(UserActivityActions.DeleteUserActivity, {
        userId: this.userId,
        recentItemId: value.id,
        all: false
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../styles/colors.scss';
@import '../../styles/variables.scss';

span {
  margin-right: 2px;
}
.delete-btn {
  position: relative;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 100%;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:hover {
    background-color: $light-grey-2;
    color: $red;
    cursor: pointer;
  }
}
</style>
